import React from 'react';
import {MapContainer,CircleMarker,Tooltip} from 'react-leaflet';
import OfflineImageryLayer from './OfflineImageryLayer';
import MapCredits from './MapCredits';
import {pointCoordinates} from '../services/placeModel';
export default function PlaceLocationMap({coordinates,name}:{coordinates:string;name:string}){
 const point=pointCoordinates({coordinates_geojson:coordinates});
 if(!point||Math.abs(point[0])>90||Math.abs(point[1])>180)return <p className="rounded-xl bg-stone-100 p-5 text-sm text-stone-500">Location unavailable.</p>;
 return <div className="h-48 sm:h-60 rounded-xl overflow-hidden border isolate" aria-label={'Location of '+name}>
  <MapContainer key={coordinates} center={point} zoom={17} maxZoom={20} attributionControl={false} scrollWheelZoom={false} style={{height:'100%',width:'100%'}}>
   <OfflineImageryLayer/><CircleMarker center={point} radius={8} pathOptions={{color:'white',weight:3,fillColor:'#3a493f',fillOpacity:1}}><Tooltip>{name}</Tooltip></CircleMarker><MapCredits/>
  </MapContainer>
 </div>;
}
